import { render } from "./RecycleBin.vue?vue&type=template&id=558a6a18&scoped=true"
import script from "./RecycleBin.vue?vue&type=script&lang=js"
export * from "./RecycleBin.vue?vue&type=script&lang=js"

import "./RecycleBin.vue?vue&type=style&index=0&id=558a6a18&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558a6a18"]])

export default __exports__